<template>
  <v-app>
    <v-toolbar flat>
      <v-btn to="/home">返回首页</v-btn>
      <v-btn-toggle color="primary" mandatory dense group class="ml-n2">
        <v-btn value="0" class="ml-2">应用管理</v-btn>
        <v-btn value="1" class="ml-2">单位管理</v-btn>
      </v-btn-toggle>
    </v-toolbar>
  </v-app>
</template>
<script>
export default {
  name: "Uams",
  data: () => ({}),
};
</script>
<style lang="scss">
</style>